<template>
  <div class="max-w-4xl p-5 mx-auto">
    <PageHeader title="Edit Automation" :subtitle="automationTypes[form.type].name" :back-route="{ name: 'AutomationList' }">
      <label class="flex items-center form-label">
        <toggle :value.sync="form.enabled" class="mr-4" /> 
        Enable This Automation
      </label>
    </PageHeader>

    <Loading v-if="loading" class="p-8" />

    <div v-else>
      <form @submit.prevent="saveAutomation()" class="pb-6 space-y-6">
        <automation-form :form="form" :methods="methods" />
        <div class="flex justify-between px-1 py-6">
          <button type="submit" class="btn btn-primary" v-submitting="submitting">Save Changes</button>
          <button type="button" class="font-medium text-red-500 hover:underline" @click="deleteAutomation()" v-submitting="submitting">Delete Automation</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import AutomationForm from './AutomationForm'

  export default {
    name: 'AutomationEdit',

    metaInfo: {
      title: 'Edit Automation'
    },

    components: {
      AutomationForm
    },

    created () {
      this.getAutomation()
    },

    computed: {
      ...mapState(['automationTypes'])
    },

    data () {
      return {
        loading: true,
        submitting: false,
        form: {
          name: '',
          type: '',
          emails: [],
          cellphones: [],
          vehicles: [],
          areas: [],
          schedules: [],
          area_policy: '',
          threshold: 0,
          condition: 0,
          notify_driver: false,
          driver_message: '',
          activate_output: false,
          send_webfleet_notification: false,
          trigger_dashboard_alert: false,
          require_acknowledgement: false,
          enabled: false
        },
        methods: {
          toggleArea: this.toggleArea,
          toggleSchedule: this.toggleSchedule,
          toggleContact: this.toggleContact,
          toggleVehicle: this.toggleVehicle,
          toggleAllVehiclesOn: this.toggleAllVehiclesOn,
          toggleAllVehiclesOff: this.toggleAllVehiclesOff
        }
      }
    },

    methods: {
      async getAutomation () {
        try {
          const { data } = await this.$api.get(`account/${this.$route.params.account}/automations/${this.$route.params.id}`)
          if (data.automation.deleted_at) {
            this.$toasted.show('The automation you requested was deleted.')
            this.$router.push({ name: 'AutomationList' })
          }
          this.form = data.automation
          this.loading = false
        } catch (error) {
          console.error(error)
        }
      },

      async saveAutomation () {
        try {
          this.submitting = true
          await this.$api.patch(`account/${this.$route.params.account}/automations/${this.$route.params.id}`, this.form)
          this.$router.push({ name: 'AutomationList' })
          this.$toasted.show('Automation updated.')
        } catch (error) {
          console.error(error)
        } finally {
          this.submitting = false
        }
      },

      async deleteAutomation () {
        if (window.confirm('Are you sure you want to delete this automation?')) {
          try {
            this.submitting = true
            await this.$api.delete(`account/${this.$route.params.account}/automations/${this.$route.params.id}`)
            this.$router.push({ name: 'AutomationList' })
            this.$toasted.show('Automation deleted.')
          } catch (error) {
            console.error(error)
          } finally {
            this.submitting = false
          }
        }
      },

      toggleAllVehiclesOn (vehicles) {
        this.form.vehicles = JSON.parse(JSON.stringify(vehicles))
      },

      toggleAllVehiclesOff () {
        this.form.vehicles = []
      },

      toggleVehicle (vehicle) {
        let index = this.form.vehicles.findIndex(v => v.id === vehicle.id)

        if (index > -1) {   
          this.$delete(this.form.vehicles, index)
        } else {
          this.$set(this.form.vehicles, this.form.vehicles.length, vehicle)
        }
      },

      toggleContact (type, contact) {
        let contactType = type + 's'
        let index = this.form[contactType].findIndex(c => c.id === contact.id)

        if (index > -1) {
          this.$delete(this.form[contactType], index)
        } else {
          this.$set(this.form[contactType], this.form[contactType].length, contact)
        }
      },

      toggleSchedule (schedule) {
        let index = this.form.schedules.findIndex(s => s.id === schedule.id)

        if (index > -1) {
          this.$delete(this.form.schedules, index)
        } else {
          this.$set(this.form.schedules, this.form.schedules.length, schedule)
        }
      },

      toggleArea (area) {
        let index = this.form.areas.findIndex(a => a.id === area.id)

        if (index > -1) {
          this.$delete(this.form.areas, index)
        } else {
          this.$set(this.form.areas, this.form.areas.length, area)
        }
      }
    }
  }
</script>